import * as Yup from "yup";

export const changePasswordFormValidation = Yup.object().shape({
  password: Yup.string().required("Password is required!"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), undefined],
    "Passwords must match!"
  ),
});
